import { DateTime } from "luxon";
import React from "react";
import UAParser from "ua-parser-js";
import packageInfo from "../../../package.json";
import { instanceConfig } from "../../config";
import Swal from "../../shared/Swal";
import Widget from "../Widget";
import "./About.scss";
import instructionPng from "./images/about_instruction-for-use.png";
import importerPng from "./images/about_importer.png";

export default class About extends Widget {
  constructor(props) {
    super(props);
    this.clickLogo = this.clickLogo.bind(this);
    this.state = {
      logoClicks: 0,
    };
    this.ua = UAParser(navigator.userAgent);
  }

  render() {
    return (
      <div className="about widget">
        <h1>About</h1>

        <h2>Application Info</h2>
        <div className="row">
          <span className="label">App Name</span>
          <span className="value">{packageInfo.appName}</span>
        </div>
        <div className="row">
          <span className="label">App Version</span>
          <span className="value">{packageInfo.version}</span>
        </div>
        <div className="row">
          <span className="label">Build Number</span>
          <span className="value">{process.env.REACT_APP_BUILD_BUILDID}</span>
        </div>
        <div className="row">
          <span className="label">UDI</span>
          <span className="value">{packageInfo.UDI}</span>
        </div>
        <div className="row">
          <span className="label">Copyright</span>
          <span className="value">
            {packageInfo.copyright.replace(
              "{YYYY}",
              DateTime.now().toFormat("yyyy"),
            )}
          </span>
        </div>
        <div className="row">
          <span className="label">Patent Number</span>
          <span className="value">{packageInfo.patentNumber}</span>
        </div>

        <h2>Device Info</h2>
        {this.ua.device.model ? (
          <div className="row">
            <span className="label">Device</span>
            <span className="value">
              {this.ua.device.vendor} {this.ua.device.type}{" "}
              {this.ua.device.model}
            </span>
          </div>
        ) : null}
        <div className="row">
          <span className="label">Operating System</span>
          <span className="value">{this.ua.os.name} </span>
        </div>
        <div className="row">
          <span className="label">Operating System Version</span>
          <span className="value">{this.ua.os.version}</span>
        </div>
        <div className="row">
          <span className="label">Browser Type</span>
          <span className="value">{this.ua.browser.name}</span>
        </div>
        <div className="row">
          <span className="label">Browser Version</span>
          <span className="value">{this.ua.browser.version}</span>
        </div>

        <h2>Technical Support</h2>
        <Row
          label={
            <img
              src={instructionPng}
              alt="instructions"
              className="instruction-img"
            />
          }
        >
          <a href={packageInfo.userGuide}>User Guides and Training</a>
        </Row>
        <Row label="Phone US Toll-free (24/7)">
          <a href={`tel:${packageInfo.phoneSupport.US}`}>
            {packageInfo.phoneSupport.US}
          </a>
        </Row>
        <Row label="Phone UK (24/7)">
          800:{" "}
          <a href={`tel:${packageInfo.phoneSupport.UK}`}>
            {packageInfo.phoneSupport.UK}
          </a>
        </Row>
        <Row label="Phone CA (24/7)">
          <a href={`tel:${packageInfo.phoneSupport.CA}`}>
            {packageInfo.phoneSupport.CA}
          </a>
          , Option 2
        </Row>
        <Row label="Phone AU (24/7)">
          <a href={`tel:${packageInfo.phoneSupport.AU}`}>
            {packageInfo.phoneSupport.AU}
          </a>
        </Row>
        <div className="row">
          <span className="label">Email Support</span>
          <span className="value">
            <a
              href={`mailto:${
                packageInfo.emailSupport
              }?subject=${encodeURIComponent(
                "Airstrip One Web - Help",
              )}&body=${encodeURIComponent(
                `\n\n-------Debugging information-------- \n User Agent: ${
                  navigator.userAgent
                }\n Build: ${packageInfo.buildDisplayName}\n Location: ${
                  window.location.href
                }\n Configuration: ${JSON.stringify(
                  instanceConfig,
                  null,
                  2,
                )}\n-----------------End----------------\n\n`,
              )}`}
            >
              {packageInfo.emailSupport}
            </a>
          </span>
        </div>

        <h2>Manufactured By</h2>
        <div className="row">
          <span className="label icon-factory"></span>
          <span className="value">
            AirStrip Technologies Inc.
            <br />
            2915 W. Bitters Rd. Suite 215
            <br />
            San Antonio, TX 78248 USA
          </span>
        </div>
        <div className="row build-date">
          <span className="label icon-factory2"></span>
          <span className="value">{packageInfo.manufactureDate}</span>
        </div>

        <h2>EU Authorized Representative & Importer</h2>
        <div className="row">
          <div className="column">
            <span className="label icon-ec-rep"></span>
            <img
              src={importerPng}
              alt="instructions"
              className="importer-img"
            />
          </div>

          <span className="value">
            MedEnvoy Global B.V.
            <br />
            Prinses Margrietplantsoen 33 - Suite 123
            <br />
            2595 AM The Hague
            <br />
            The Netherlands
          </span>
        </div>

        <h2>UK Responsible Person & Importer</h2>
        <div className="row">
          <div className="column">
            <img src={importerPng} alt="importer" className="importer-img" />
          </div>

          <span className="value">
            MedEnvoy UK Limited
            <br />
            85, Great Portland Street, First Floor
            <br />
            London, W1W 7LT
            <br />
            United Kingdom
          </span>
        </div>

        <h2>AU Authorized Representative</h2>
        <div className="row">
          <span className="label icon-ec-rep hide"></span>
          <span className="value">
            Cardioscan Services Pty Ltd.
            <br />
            293 Camberwell Rd. Suite 301
            <br />
            Victoria 3124 Australia
            <br />
            +61 3 9832 2222
            <br />
            0 3 9832-2222
            <br />
          </span>
        </div>

        <a href={packageInfo.EULA} className="eula">
          End User License Agreement
        </a>
        <div className="logos" onClick={this.clickLogo}></div>
        {this.state.devMode ? (
          <div className="dev-tools">
            <h1>dev info</h1>
            <pre>{JSON.stringify(instanceConfig, null, 2)}</pre>
          </div>
        ) : null}
      </div>
    );
  }
  clickLogo() {
    this.setState({ logoClicks: this.state.logoClicks + 1 });
    if (this.state.logoClicks >= 10) {
      this.state.devMode = true;
    }
  }
}

function Row(props) {
  return (
    <div className="row">
      <span className="label">{props.label}</span>
      <span className="value">{props.children}</span>
    </div>
  );
}

export function popupAbout() {
  this.props.store.userMenuOpen = false;
  Swal.fire({
    html: (
      <div id="about-airstrip">
        <About store={this.props.store} />
      </div>
    ),
    customClass: "about",
    confirmButtonText: "Done",
    animation: false,
    position: "top",
  });
}
